import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { LOG_LEVELS } from '../util/constants';
import { LogService } from './shared/log.service';
import { NGaugeService } from './shared/ngauge.service';
import { UserService } from './user.service';
import { AuthService } from './shared/auth.service';

interface BroadcastEvent {
  key: any;
  data?: any;
}

@Injectable()
export class CalendarService {
  private _eventBus: Subject<BroadcastEvent>;
  notifications: any;
  notificationData: any;
  selectedMonth: any;
  selectedEvent: any;
  notesAction = new Subject();
  notesData = new Subject();

  constructor(private httpClient: HttpClient,
    private logService: LogService,
    private authservice:AuthService,
    private ngaugeService: NGaugeService) {
    this._eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({ key, data });
  }

  createTasks(taskDetail) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('CREATETASK'), { 'taskdetail': taskDetail });
  }

  setNotes(notes: any) {
    this.notesData.next(notes);
  }

  getNotes() {
    return this.notesData.asObservable();
  }

  setNotesAction(setNotes: any) {
    this.notesAction.next(setNotes);
  }

  getNotesAction() {
    return this.notesAction.asObservable();
  }

  saveNotes(notesDetail) {
    notesDetail['status'] = 'notread';
    let sid=this.authservice.getSID()
    if (notesDetail['id'] === undefined) {
      return this.httpClient.post(this.ngaugeService.getMeldURL('CREATE_PROPERTY_NOTES'), { notesinfo: notesDetail,SID:sid });
    } else {
      return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATENOTES'), { notesdetail: notesDetail,SID:sid });
    }
  }

  getAllNotes(startDate, endDate) {
    const filter = '?startDate=' + startDate + '&endDate=' + endDate + '&SID='+ this.authservice.getSID();
    this.httpClient.get(this.ngaugeService.getMeldURL('CALENDARINFO') + filter).subscribe(notesInfo => {
      this.notificationData = notesInfo;
      if (notesInfo['result']) {
        this.notifications = this.notificationData.result.notes;
      }
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'On Calendar Service', 'On Fetch Notes', JSON.stringify(error));
    });
  }
  getAllNotifications() {
    return this.notifications;
  }
  setMonth(value) {
    this.selectedMonth = value;
  }

  getMonth() {
    return this.selectedMonth;
  }

  setEvent(event) {
    this.selectedEvent = event;
  }

  getEvent() {
    return this.selectedEvent;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/calendar.service.ts